<template>
  <div class="head-page">
    <Header :title="$t('loans.title')" />
    <van-tabs v-model="active">
      <van-tab :title="$t('loans.order_tab')" />
      <van-tab :title="$t('loans.pro_tab')" />
    </van-tabs>
    <div class="head-tab-page-overflow">
      <div v-if="active == 0">
        <van-cell
          :title="statuslabel"
          is-link
          arrow-direction="down"
          @click="show = true"
        />
        <div class="data-box" v-if="list.length > 0">
          <van-pull-refresh
            :pulling-text="$t('common.pulling')"
            :loosing-text="$t('common.loosing')"
            :loading-text="$t('common.loading')"
            v-model="refreshing"
            @refresh="onRefresh"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="$t('common.nomore')"
              :loading-text="$t('common.loading')"
              :error-text="$t('common.errortxt')"
              @load="onLoad"
            >
              <LoanOrder v-for="(item, index) in list" :item="item" :key="index" @reset-data="ResetData" />
            </van-list>
          </van-pull-refresh>
        </div>
        <div v-else class="data-box">
          <van-empty :description="$t('common.nodata')" />
        </div>
      </div>
      <div v-if="active == 1">
        <div v-if="datas && datas.length > 0">
          <LoanPro v-for="(item, index) in datas" :item="item" :key="index" />
        </div>
        <div v-else>
          <van-empty :description="$t('common.nodata')" />
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="statuscol"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { LoanPro, LoanOrder } from "./components/index";
export default {
  name: "LoansView",
  components: { Header, LoanPro, LoanOrder },
  data() {
    return {
      active: 1,
      datas: [],

      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,

      show: false,
      statuslabel: null,
      statusval: null,
      statuscol: [
        { value: 0, label: this.$t("common.all") },
        { value: 1, label: this.$t("loans.status1") },
        { value: 2, label: this.$t("loans.status2") },
        { value: 3, label: this.$t("loans.status3") },
        { value: 4, label: this.$t("common.canceled") },
      ],
    };
  },
  watch: {
    active(newVal) {
      if (newVal == 1) {
        this.getDataPro();
      } else {
        this.onRefresh();
      }
    },
  },
  mounted() {
    this.getDataPro();
    this.statuslabel = this.statuscol[0].label;
    this.statusval = this.statuscol[0].value;
  },
  methods: {
    ResetData(){
      this.onRefresh()
    },
    onConfirm(val) {
      this.statuslabel = val.label;
      this.statusval = val.value;
      this.show = false;
      this.onRefresh()
    },
    async getDataPro() {
      await this.$http({
        method: "post",
        url: "getLoanProjects",
      }).then((res) => {
        this.datas = res.data.list;
      });
    },
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getLoanRecords",
        data: {
          status: this.statusval,
          page: this.page,
          limit: this.limit,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false;
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style>
</style>
